import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'counter']

  connect() {
    this.refresh()
  }

  toggleAll(e) {
    this.checkboxTargets.forEach(box => { box.checked = e.target.checked })
    this.refresh()
  }

  refresh() {
    const picked = this.checkboxTargets.filter(box => box.checked).length
    this.counterTarget.textContent = I18n.t('announcements.back_office.scan.counter', {
      count: picked, total: this.checkboxTargets.length,
    })
    this.element.querySelectorAll('.bo-scan__item').forEach(item => {
      item.classList.toggle('is-picked', item.querySelector("input[type='checkbox']").checked)
    })
  }
}
